import { render, staticRenderFns } from "./XSSPayloads.vue?vue&type=template&id=33af82ab&"
import script from "./XSSPayloads.vue?vue&type=script&lang=js&"
export * from "./XSSPayloads.vue?vue&type=script&lang=js&"
import style0 from "./XSSPayloads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports